<template>
    <div>
        <div v-for="(card, n) of data" :key="n" class="user-statistics" style="max-width: 1120px">
            <div class="block-info">
                <div class="mobile dropdown-fixer">
                    <v-dropdown>
                        <router-link :to="{ name: 'forex-license-page-with-id', params: { id: card.id } }">
                            <button class="course-link">
                                <div style="font-size: 24px" class="small-modal__svg">
                                    <v-icon :src="'edit'" />
                                </div>
                                Редактировать
                            </button>
                        </router-link>
                        <button @click="openSettingModal(card.id)" class="course-link">
                            <div class="small-modal__svg">
                                <v-icon :src="'settings'" />
                            </div>
                            Настройки
                        </button>
                        <button
                            v-if="![5, 6].includes(card.status.id)"
                            @click="openConfirmDeleteModal(card.id)"
                            class="course-link"
                        >
                            <div class="small-modal__svg">
                                <v-icon :src="'delete'" />
                            </div>
                            Удалить
                        </button>
                    </v-dropdown>
                </div>
                <div class="block-info__header">
                    <div style="align-content: flex-start" class="flex-row title-header">
                        <div class="status-icon">
                            <v-icon :src="statusIcons[card.status.id]" />
                        </div>
                        <div>
                            <div class="title">Заявка #{{ card.id }}</div>
                            <div style="min-width:150px">
                                <!--                                <small>Депозит: </small><span class="sum-value"> $ {{ card.stat.info.deposit }}</span>-->
                                <!--                        <small>Работает с {{ card.created_at }}</small>-->
                            </div>
                        </div>
                        <div class="mobile card-status" :class="statusClasses[card.status.id]">
                            {{ card.status.label }}
                        </div>
                    </div>
                </div>
                <div class="block-info__body month-mobile">
                    <div class="block-info__body-date">
                        <div class="box__today">
                            <div class="flex-row" style="justify-content: center">
                                <span
                                    class="big-profit"
                                    style="margin-right: 10px"
                                    :class="true || card.stat.info.profit.today.value >= 0 ? 'c-profit' : 'c-decline'"
                                >
                                    <!--                                    {{ convertNum(card.stat.info.profit.today.value) }}$-->
                                    --
                                </span>
                                <!--                                <badge-indicator :value="card.stat.info.profit.today.percent" size="lg" />-->
                            </div>
                            <span style="color: #1D2228; font-size: 18px;"
                                >сегодня {{ card.stat.info.updated_at }}</span
                            >
                        </div>
                    </div>
                    <div class="flex-row month-desktop " style="order:1">
                        <div class="box__dates">
                            <div>Тек. Месяц:</div>
                            <div>Пред. месяц:</div>
                        </div>
                        <div style="padding-left:15px;" class="box__profit">
                            <div>
                                <small>
                                    <span :class="assignClass(card.stat.info.profit.month.value)">
                                        <!--                                        {{ convertNum(card.stat.info.profit.month.value) }}$-->
                                        --
                                    </span>
                                    <!--                                    ({{ card.stat.info.profit.month.percent }}%)-->
                                    --
                                </small>
                            </div>
                            <div>
                                <small>
                                    <span :class="assignClass(card.stat.info.profit.prev_month.value)">
                                        <!--                                        {{ convertNum(card.stat.info.profit.prev_month.value) }}$-->
                                        --
                                    </span>
                                    <!--                                    ({{ card.stat.info.profit.prev_month.percent }}%)-->
                                    --
                                </small>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex-row desktop"
                        :class="statusClasses[card.status.id]"
                        style="order:2;padding-left: 10px"
                    >
                        {{ card.status.label }}
                    </div>
                    <div class="flex-row desktop" style="order:3;padding-left: 10px">
                        <router-link :to="{ name: 'forex-license-page-with-id', params: { id: card.id } }">
                            <button class="v-button taplink-preview v-button-icon v-button-icon--secondary md">
                                <v-icon :src="'edit'"></v-icon>
                            </button>
                        </router-link>
                        <button
                            @click="openSettingModal(card.id)"
                            style="margin-left: 10px"
                            class="v-button taplink-preview v-button-icon v-button-icon--secondary md"
                        >
                            <v-icon :src="'settings'"></v-icon>
                        </button>
                        <button
                            v-if="![5, 6].includes(card.status.id)"
                            @click="openConfirmDeleteModal(card.id)"
                            style="margin-left: 10px"
                            class="v-button taplink-preview v-button-icon md"
                        >
                            <v-icon :src="'delete'"></v-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BadgeIndicator from "./BadgeIndicator";
import VButton from "@/updated/common/components/VButton";

import { api } from "../services";

const statuses = {
    0: "wait",
    1: "ok",
    2: "wait",
    3: "reject",
    4: "off",
    5: "off",
    6: "off",
    7: "reject"
};

const statusClasses = {
    0: "pending",
    1: "success",
    2: "pending",
    3: "error",
    4: "off",
    5: "off",
    6: "off",
    7: "error"
};

const statusIcons = {
    0: "load",
    1: "ok-green",
    2: "load",
    3: "error",
    4: "info",
    5: "delete",
    6: "delete",
    7: "error"
};

export default {
    name: "PlOrdersTab",
    components: {
        VButton,
        BadgeIndicator
    },
    $_veeValidate: {
        validator: "new"
    },
    props: {
        data: {},
        page: {}
    },
    data() {
        return {
            fullAllowed: false,
            testAllowed: false,
            statusIcons,
            statuses,
            statusClasses,
            orders: []
        };
    },
    created() {},
    mounted() {},
    computed: {},
    methods: {
        openSettingModal(cardId) {
            this.openModal("PlForexSettings", { cardId: cardId })
                .then(() => {
                    this.$emit("update");
                })
                .finally(() => {});
        },
        openConfirmDeleteModal(cardId) {
            this.openModal("PlForexConfirmDelete", {})
                .then(data => {
                    if (data === true) {
                        api.deleteOrder(cardId)
                            .then(() => {
                                this.notify({ title: "Заявка успешно удалена" });
                                this.$emit("update");
                            })
                            .catch(() => {
                                this.notify({ type: "error", title: "Ошибка при удалении заявки" });
                            });
                    }
                })
                .finally(data => {});
        },
        async updateSettings() {
            await api.updateSettings(this.settings.drying);
            this.notify({ title: "Сохранено" });
        },
        convertNum(num) {
            return num > 0 ? `+${num}` : num;
        },
        assignClass(num) {
            return "c-profit";
            // if (num === 0) return "";
            // return num > 0 ? "c-profit" : "c-decline";
        }
    }
};
</script>

<style scoped lang="scss">
.off {
    color: blue;
}

.status-icon {
    min-width: 48px;
    vertical-align: middle;
    margin-top: 10px;
    font-size: 32px;
}

.course-link {
    display: flex;
    color: #58606e;
}

.success {
    color: green;
}

.pending {
    color: orange;
}

.error {
    color: red;
}

.admin-actions {
    display: flex;

    .v-button {
        margin-right: 10px;
    }

    .status {
        font-size: 14px;
        font-weight: 700;
        display: flex;
        margin-bottom: 20px;

        .svg-icon {
            margin-right: 5px;
        }
    }
}

.form-container {
    margin-bottom: 20px;
    max-width: 810px;
    width: 100%;

    &.is-disabled {
        padding: 30px;
        border-radius: 12px;
        background: linear-gradient(to bottom, #fcfcfc 00%, #f0eff1 46%);
    }
}

.status-box {
    max-width: 550px;
    width: 100%;
    padding: 17px;
    padding-right: 40px;
    background: #fff;
    border: 1px solid #faac15;
    border-radius: 2px;
    display: flex;
    margin-bottom: 20px;

    &.ok {
        border-color: #28cc6c;
    }

    &.reject {
        border-color: #f65844;
    }

    .left {
        margin-right: 18px;
        padding-top: 4px;
    }

    .subtitle {
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #1d2228;
        margin-bottom: 8px;
    }

    p {
        font-size: 14px;
        line-height: 20px;
        color: #58606e;
        margin: 0;
    }
}

.btn-accept-application {
    margin-bottom: 24px;
}

.page-back {
    margin-bottom: 0;
}

.page-instructions {
    display: flex;
    align-items: center;
    margin-bottom: 26px;

    .svg-icon {
        margin-right: 10px;
        font-size: 20px;
    }
}

.form {
    &-application {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .form-group-wrap {
            width: 100%;
            border-radius: 12px;

            &:first-child {
                margin-right: 40px;
            }
        }

        .form-group {
            margin-bottom: 6px;
        }

        .form-group__ttl {
            display: inline-block;
            font-weight: 500;
            font-size: 18px;
            margin-bottom: 10px;
        }

        @media (max-width: 680px) {
            flex-direction: column;
            .form-group-wrap:first-child {
                margin-bottom: 20px;
            }
        }
    }
}

.dropdown-fixer {
    margin-top: 24px;
    align-items: center;
    width: 32px;
    height: 88px;
    position: absolute;
    right: 75px;
}

@media (max-width: 768px) {
    .dropdown-fixer {
        right: 25px;
    }
}
.card-status {
    margin-right: 75px;
}
@media (max-width: 423px) {
    .card-status {
        margin-right: 25px;
    }
    .title-header {
        justify-content: left !important;
    }
}

.forex-license-info {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 800px;
    padding: 20px 0;
    border-radius: 16px;
    /*    <!--box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2);-->
                <!--background-color: #c3cbdc;-->
                <!--background-image: linear-gradient(-47deg, #c3cbdc 0%, #edf1f4 84%);-->*/

    .form-group {
        width: 100%;

        input {
            color: #333;
        }

        &:first-child {
            max-width: 380px;
            margin-bottom: 20px;
        }

        &:last-child {
            max-width: 200px;
        }

        @media (max-width: 440px) {
            input {
                font-size: 2.8vw;
            }
        }
    }
}

.forex-statistics {
    max-width: 1120px;

    small {
        color: #58606e;
    }
}

.c-profit {
    color: #0a9744;
}

.c-decline {
    color: #f65844;
}

.sum-value {
    color: #faac15;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
}

.big-profit {
    font-weight: bold;
    font-size: 28px;
    line-height: 40px;
}

.user-statistics {
    box-shadow: 0 1px 4px rgba(57, 70, 111, 0.06), 0 6px 20px rgba(57, 70, 111, 0.08);
    border-radius: 8px;
    margin-bottom: 15px;
    overflow: hidden;

    .block-info {
        &__header {
            background: #f5f7fa;
            border: 1px solid #ebeff5;
            border-radius: 8px 8px 0 0;
            padding: 18px 16px 16px 16px;

            .title {
                color: #1d2228;
                font-size: 20px;
                line-height: 28px;
                font-weight: 500;
            }
        }

        &__body {
            padding: 18px 16px 16px 16px;
            display: flex;

            &-date {
                li {
                    font-size: 14px;
                    line-height: 24px;
                    color: #58606e;
                }

                .box__today {
                    margin-bottom: 8px;
                }

                .box__dates {
                    flex-direction: column;
                    font-size: 14px;
                    color: #58606e;
                    margin-right: 8px;
                }

                .box__profit {
                    display: flex;
                    flex-direction: column;
                }
            }

            &-profit {
                text-align: right;

                .decline {
                    margin-bottom: 18px;
                }
            }
        }
    }

    .block-pairs {
        padding: 16px;
        border-top: 1px solid #ebeff5;

        &__title {
            font-size: 14px;
            margin-bottom: 8px;
        }

        .pairs-list {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            grid-gap: 8px;

            &__item {
                display: flex;
                background: #f5f7fa;
                border: 1px solid #ebeff5;
                border-radius: 8px;

                &-body {
                    width: 100%;
                    padding: 16px 16px 11px;
                }

                &-currency {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 16px;
                    background: #ffc107;
                    border-radius: 8px;
                    font-weight: 500;

                    div:first-child {
                        margin-bottom: 5px;
                    }
                }
            }
        }
    }

    .btn-show {
        padding: 0 16px 16px;

        .v-button {
            background: #fff3cd;

            .svg-icon {
                fill: #faac15;
                font-size: 10px;
            }
        }

        &.is-active {
            .svg-icon {
                transform: rotate(180deg);
            }
        }
    }

    .desktop {
        display: none;
    }

    .month-desktop {
        padding-left: 25px;
    }

    @media (max-width: 360px) {
        .month-mobile {
            align-items: center;
            padding: none;
            width: 100%;
            flex-direction: column;
        }
    }

    .mobile {
        display: block;
    }

    @media (min-width: 1260px) {
        .mobile {
            display: none;
        }

        .desktop {
            display: flex;
        }

        .block-info {
            display: grid;
            grid-template-columns: 270px 1fr;

            &__header {
                background: #fff;
                border: none;
            }

            &__body {
                justify-content: space-between;

                &-profit {
                    height: 100%;

                    .decline {
                        margin-bottom: 0;
                    }

                    .decline,
                    .profit {
                        display: flex;
                        align-items: center;

                        span {
                            margin-left: 4px;

                            &:before {
                                content: "- ";
                            }
                        }
                    }
                }

                &-date {
                    display: flex;
                    order: 1;
                    padding-left: 20px;
                    margin-top: -7px;

                    li span {
                        font-size: 16px;
                    }

                    .box__today {
                        margin-bottom: 0;
                        margin-right: 20px;
                    }
                }
            }
        }
        .block-pairs {
            .pairs-list {
                column-gap: 16px;
                row-gap: 16px;
            }
        }
        .btn-show {
            display: none;
        }
    }
}

.card-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 16px;

    &__header {
        background: #ebeff5;
        border-radius: 4px;
        padding: 10px 18px;
        margin-bottom: 24px;

        button {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            strong {
                order: 1;
                margin-right: auto;
            }

            .svg-icon {
                order: 0;
                padding: 4px;
                font-size: 18px;
                margin-right: 10px;
            }

            &.is-active {
                .svg-icon {
                    transform: rotate(180deg);
                }
            }

            @media (min-width: 640px) {
                strong {
                    order: 0;
                }
                .svg-icon {
                    order: 1;
                }
            }
        }
    }

    &__item {
        padding: 8px 24px 12px 16px;
        background: #f5f7fa;
        border: 1px solid #ebeff5;
        border-radius: 8px;

        &-name {
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
        }
    }

    @media (min-width: 769px) {
        grid-gap: 32px;
    }
}

.flex-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
